import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export const ScrollUpButton = ({ target = undefined }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const onScroll = (e) => {
    const scrollY = e.currentTarget.scrollY || window.pageYOffset || 0;
    setVisible(scrollY > 300);
  };

  const onScrollToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    return false;
  };

  const onScrollToTarget = () => {
    target?.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={`btn-scrolltop${visible ? ' visible' : ''}`} onClick={target ? onScrollToTarget : onScrollToTop}>
      <div className="btn-scrolltop-arrow"></div>
    </div>
  );
};

ScrollUpButton.propTypes = {
  target: PropTypes.object
};

export default ScrollUpButton;
